import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
	key: 'user',
});

const userDataState = atom({
	key: 'userData',
	default: '',
	effects_UNSTABLE: [persistAtom],
});

export default userDataState;
